import {
  connect
} from 'react-redux';
import CallbackView from './CallbackView';

function mapStateToProps(state) {
  return {
    auth: state.users.auth,
    authCode: state.callback.authCode,
    error: state.callback.error,
  }
}

export default connect(mapStateToProps)(CallbackView);


// WEBPACK FOOTER //
// ./src/modules/callback/CallbackContainer.js